import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  signal,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styles: [
    `
      .star {
        cursor: pointer;
        transition: color 0.2s ease-in-out;
        color: var(--color-primary);
      }

      .star:hover,
      .star.previous-hovered {
        color: gold;
      }
    `,
  ],
  standalone: false,
})
export class StarRatingComponent {
  @Input() set rating(_rating: number) {
    this.setRating(_rating, true);
    this.lastHoveredStar.set(null);
  }
  @Input() editable = false;
  @Output() ratingChange = new EventEmitter<number>();

  readonly maxRating = 5;
  readonly currentRating = signal(0);
  readonly lastHoveredStar = signal<number | null>(null);

  readonly hasHalfStar = computed(() => this.currentRating() % 1 !== 0);
  readonly filledStars = computed(() =>
    indexes(Math.floor(this.currentRating()))
  );
  readonly emptyStars = computed(() =>
    indexes(this.maxRating - Math.ceil(this.currentRating()))
  );
  readonly allFilledStarsLength = computed(
    () => this.filledStars().length + (this.hasHalfStar() ? 1 : 0)
  );

  setRating(rating: number, isInit = false) {
    if (this.editable || isInit) {
      this.currentRating.set(rating);
      this.ratingChange.emit(rating);
    }
  }

  hoverStar(index: number | null) {
    this.lastHoveredStar.set(index);
  }
}

function indexes(count: number): number[] {
  return Array.from({ length: Math.max(count, 0) }, (_, i) => i);
}
